"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseClassName = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const join_1 = tslib_1.__importDefault(require("../utils/join"));
exports.baseClassName = 'ab-HelpBlock';
const HelpBlock = (props) => {
    return React.createElement(rebass_1.Box, Object.assign({}, props, { className: (0, join_1.default)(props.className, exports.baseClassName) }));
};
exports.default = HelpBlock;
